module.exports = __webpack_public_path__ + "img/cheliangshangbao.24635c80.png";